import { DataService } from './dataService'
const individualServices = {
    add_individual: async (data) => {
        return DataService.post('/admin/add_individual', data)
    },

    update_individual: async (data) => {
        return DataService.post('/admin/update_individual', data)
    },

    get_individual_details: async (data) => {
        return DataService.get('/admin/get_individual_details?id=' + data.id)
    },


    get_individual: async (data) => {
        return DataService.get('/admin/get_individual', data)
    },
    addAdvanceAmount: async (data) => {
        return DataService.post('/admin/qbook/advancePayment', data)
    },

}


export default individualServices